// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_hints_1ubbm_1ylfn_10:not(#\\9){margin-block-start:var(--space-static-xxs-z6w5bq, 4px)}\n", ""]);
// Exports
module.exports = exports;
